export default function isValidLatLon(lat: number | null, lon: number | null): boolean {
    return (
        typeof lat === 'number' &&
        typeof lon === 'number' &&
        -90 <= lat &&
        lat <= 90 &&
        -180 <= lon &&
        lon <= 180
    );
}
